/*global _api*/
import store from '@/store/'
import axios from 'axios'

export let CALCULATION = axios.create({
	baseURL: _api.calculation,
	headers: {
		Authorization: `${store ? store.getters.getAccessToken : ''}`
	},
	timeout: 0
});